import styled, { css } from 'styled-components';

export const FieldLabel = styled.label`
  margin: 12px 0;
  font-weight: 500;
  font-size: ${(props) => props.fontSize || '13px'};
  color: rgba(26, 26, 26, 0.7);
`;

const stripeStyleBase = css`
  width: 100%;
  padding: 8px 12px;
  box-shadow: 0 0 0 1px #e0e0e0, 0 2px 4px 0 rgba(0, 0, 0, 0.07), 0 1px 1.5px 0 rgba(0, 0, 0, 0.05);
`;

export const CardField = styled.div`
  display: flex;
  margin-bottom: 10px;

  .stripe-element {
    height: 35px;
  }

  #stripe-card-number {
    ${stripeStyleBase}
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }

  #stripe-expiry {
    ${stripeStyleBase}
    padding: 8px 12px;
    border-bottom-left-radius: 6px;
  }

  #stripe-cvc {
    ${stripeStyleBase}
    font-size: 14px;
    padding: 8px 12px;
    border-bottom-right-radius: 6px;
  }
`;

export const PaymentProcessorContainer = styled.div`
  max-width: 500px;
  padding: 1px;
  @media screen and (max-width: 756px) {
    max-width: none;
    width: 100%;
  }
`;
